<template>
  <div class="home-root">
    <!-- <main class="main-section">
      <h1 class="main-title" id="main-title">跨境精细化运营工具</h1>
      <div class="main-desc">批量自动采集上品、自动核价、库存同步、AI图片翻译，AI自动类目匹配，标题AI优化，自动报名活动 </div>
      <div class="main-btns">
        <button class="main-btn" @click="onDownloadClick">下载插件「聚宝铺」</button>
        <button class="ghost-btn" @click="onDocClick">查看说明文档</button>
      </div>
    </main> -->

    <!-- 轮播图部分 -->
    <section class="carousel-section">
      <div class="carousel-container">
        <el-carousel 
          height="400px" 
          :interval="4000" 
          trigger="hover"
          indicator-position="inside"
          arrow="hover"
        >
                     <el-carousel-item v-for="(image, index) in carouselImages" :key="index">
             <div class="carousel-item">
               <img :src="isMobile() ? image.h5Src : image.src" :alt="image.alt" class="carousel-image" />
             </div>
           </el-carousel-item>
        </el-carousel>
      </div>
    </section>

    <section class="feature-section" id="feature-intro">
      <div class="feature-card feature-grid-card">
        <h2 class="feature-main-title">立即了解聚宝铺产品能力</h2>
        <div class="feature-sub-title">适配Temu半托管、Temu全托。<br/>支持自动上品站点：美国、欧盟、英国、澳大利亚、加拿大、日韩等<br/></div>
        <!-- <div class="feature-visual">
          <svg class="visual-bg" width="480" height="260" viewBox="0 0 480 260">
            <defs>
              <radialGradient id="glow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stop-color="#4b70eb" stop-opacity="0.10"/>
                <stop offset="100%" stop-color="#4b70eb" stop-opacity="0"/>
              </radialGradient>
            </defs>
            <circle cx="240" cy="130" r="100" fill="url(#glow)"/>
            <circle cx="240" cy="130" r="100" stroke="#4b70eb99" stroke-width="3" fill="none"/>
            <circle cx="240" cy="130" r="150" stroke="#4b70eb44" stroke-width="1.5" fill="none" stroke-dasharray="8 6"/>
          </svg>
          <div class="visual-center">
            <img src="@/assets/logo.png" class="visual-logo" />
          </div>
          <div class="visual-label visual-ai">AI</div>
          <div class="visual-label visual-batch">批量上品</div>
          <div class="visual-label visual-jingxi">精细化店铺运营</div>
          <div class="visual-label visual-auto">自动化</div>
        </div> -->
        <div class="feature-grid">
          <template v-for="(item, idx) in features" :key="idx">
            <div
              class="feature-item"
              :class="{ clickable: idx === features.length - 1, more: idx === features.length - 1 }"
              @click="() => { if(idx === features.length - 1) onDocClick() }"
              tabindex="0"
              style="user-select: none;"
            >
              <div class="feature-icon" :class="{ 'more-glow': idx === features.length - 1 }">
                <template v-if="idx !== features.length - 1">
                  {{ icons[idx] }}
                </template>
                <template v-else>
                  <svg class="glow-star" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <defs>
                      <radialGradient id="star-glow" cx="50%" cy="50%" r="50%">
                        <stop offset="0%" stop-color="#fffbe6" stop-opacity="1"/>
                        <stop offset="100%" stop-color="#ffe066" stop-opacity="0"/>
                      </radialGradient>
                      <linearGradient id="star-main" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#ffe066"/>
                        <stop offset="100%" stop-color="#ffb300"/>
                      </linearGradient>
                    </defs>
                    <circle cx="24" cy="24" r="20" fill="url(#star-glow)" opacity="0.7"/>
                    <path d="M24 10l3.09 8.26H36l-6.545 5.24L31.18 32 24 26.92 16.82 32l1.725-8.5L12 18.26h8.91L24 10z"
                      fill="url(#star-main)" stroke="#ffd700" stroke-width="1.5"/>
                  </svg>
                </template>
              </div>
              <div class="feature-title">{{ item }}</div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <!-- 企业级解决方案部分 -->
    <section class="enterprise-section">
      <div class="enterprise-card">
        <h2 class="enterprise-main-title">企业级一站式电商运营解决方案</h2>
        <div class="enterprise-sub-title">精细化跨境运营工具，批量自动采集上品、自动核价、库存同步、AI图片翻译，AI自动类目匹配，标题AI优化，自动报名活动</div>
          <div class="enterprise-grid">
           <div class="enterprise-item">
             <div class="enterprise-header">
               <div class="enterprise-avatar">
                 <img src="../assets/qiye/7592cd5073928e2f4f65ef7bb9f447c0.png" alt="用户头像" />
               </div>
               <div class="enterprise-info">
                 <div class="enterprise-tag enterprise-tag-blue">TEMU全托卖家</div>
                 <h3 class="enterprise-item-name">Nei*</h3>
                 <div class="enterprise-item-role">厦门某电商公司,员工</div>
                 <div class="enterprise-tag enterprise-tag-orange">初创团队版</div>
               </div>
             </div>
             <p class="enterprise-item-desc">“我们需要一款能够丝滑上品且稳定的跨境电商辅助工具，在对比多种产品后，最终选择了聚宝铺。”</p>
           </div>
           <div class="enterprise-item">
             <div class="enterprise-header">
               <div class="enterprise-avatar">
                 <img src="../assets/qiye/ae3dcafaa70f3c037e8f4a06ac33f514.png" alt="用户头像" />
               </div>
               <div class="enterprise-info">
                 <div class="enterprise-tag enterprise-tag-green">多平台卖家</div>
                 <h3 class="enterprise-item-name">Rai*</h3>
                 <div class="enterprise-item-role">厦门某电商公司,负责人</div>
                 <div class="enterprise-tag enterprise-tag-orange">中小团队版</div>
               </div>
             </div>
             <p class="enterprise-item-desc">”聚宝铺能够帮助我们在多个托管平台快逸发品，还佬快速核价，方便又稳定，大大提升了团队的效车”</p>
           </div>
           <div class="enterprise-item">
             <div class="enterprise-header">
               <div class="enterprise-avatar">
                 <img src="../assets/qiye/0a270be893e0095eba61b7ee7ab55242.png" alt="用户头像" />
               </div>
               <div class="enterprise-info">
                 <div class="enterprise-tag enterprise-tag-orange-light">TEMU半托卖家</div>
                 <h3 class="enterprise-item-name">Pika*</h3>
                 <div class="enterprise-item-role">厦门某电商公司,运营总监</div>
                 <div class="enterprise-tag enterprise-tag-orange-dark">大卖团队版</div>
               </div>
             </div>
             <p class="enterprise-item-desc">“对于卖家来说，效果是很重要的一个考量，聚宝铺在上品和报活动，解决了很多效率同题，是团从必备的效果工具。”</p>
           </div>
         </div>
      </div>
    </section>

    <!-- 价格方案部分 -->
    <!-- <Pricing :vip-plans="vipPlans" @download-plugin="handleDownloadPlugin" @show-customer-service="showCustomerServiceModal" /> -->
    
    <!-- 价格方案图片展示部分 -->
    <section class="pricing-images-section">
      <div class="pricing-images-card">
        <h2 class="pricing-images-title">店铺绑定不限上传数量</h2>
        <div class="pricing-images-grid">
            <img  class="pricing-image-item" @click="onPricingClick" :src="isMobile() ? pricingH5Images[0] : pricingWebImages[0]" alt="价格方案1" />
            <img  class="pricing-image-item" @click="onPricingClick" :src="isMobile() ? pricingH5Images[1] : pricingWebImages[1]" alt="价格方案2" />
            <img class="pricing-image-item" @click="onPricingClick" :src="isMobile() ? pricingH5Images[2] : pricingWebImages[2]" alt="价格方案3" />
            <img class="pricing-image-item" @click="onPricingClick" :src="isMobile() ? pricingH5Images[3] : pricingWebImages[3]" alt="价格方案4" />
        </div>
        <div class="pricing-images-button">
          <button class="pricing-btn" @click="onPricingClick">查看订阅方案和价格</button>
        </div>
       </div>
     </section>

     <!-- 客服微信弹窗 -->
      <el-dialog
        v-model="customerServiceVisible"
        title="客服微信"
        width="400px"
        :show-close="true"
        center
      >
        <div class="customer-service-content">
          <img 
            src="https://yootiao.top/jbp/img/wxqc.png" 
            alt="客服微信二维码" 
            class="customer-service-qr"
          />
          <p class="customer-service-text">请扫描二维码添加客服微信进行咨询</p>
          <!-- <p class="customer-service-wechat">微信号：jbp-customer-service</p> -->
        </div>
      </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { checkVersion, getShopPrices } from '../api/admin'
import Pricing from '../components/Pricing.vue'

const vipPlans = ref([])
const customerServiceVisible = ref(false)

// 功能亮点数据
const features = [
  '一键自动采集上架',
  '店铺商品日常维护',
  '自动核价',
  '自动报名活动',
  '批量上传合规信息',
  '活动页面利润显示',
  '自动智能匹配类目',
  '点击查看更多功能',
]

// 轮播图数据
const carouselImages = [
  {
    src: new URL('../assets/carousel/15fef76648ff2cbdee471663db585fe0.png', import.meta.url).href,
    h5Src: new URL('../assets/h5qiye/banner-聚宝铺插件.png', import.meta.url).href,
    alt: '聚宝铺功能展示1'
  },
  {
    src: new URL('../assets/carousel/banner-客服（新）.png', import.meta.url).href,
    h5Src: new URL('../assets/h5qiye/banner-聚宝铺插件（1）.png', import.meta.url).href,
    alt: '聚宝铺功能展示2'
  },
  {
    src: new URL('../assets/carousel/c67c4738fb062aafd0a8494cf29834bd.png', import.meta.url).href,
    h5Src: new URL('../assets/h5qiye/banner-聚宝铺插件（2）.png', import.meta.url).href,
    alt: '聚宝铺功能展示3'
  }
]

// 价格方案图片数据
const pricingH5Images = [
  new URL('../assets/h5qiye/分组 8.png', import.meta.url).href,
  new URL('../assets/h5qiye/分组 13.png', import.meta.url).href,
  new URL('../assets/h5qiye/分组 14.png', import.meta.url).href,
  new URL('../assets/h5qiye/分组 15.png', import.meta.url).href
]

const pricingWebImages = [
  new URL('../assets/py/分组 10.png', import.meta.url).href,
  new URL('../assets/py/分组 2.png', import.meta.url).href,
  new URL('../assets/py/分组 8.png', import.meta.url).href,
  new URL('../assets/py/分组 9.png', import.meta.url).href
]

// 图标数组（最后一个为null，SVG星星由模板内写死）
const icons = [
  '📦', // 一键自动采集上架
  '🛒', // 店铺商品日常维护
  '💰', // 自动核价
  '📝', // 自动报名活动
  '📄', // 批量上传合规信息
  '📊', // 活动页面利润显示
  '🔄', // 自动同步库存
  null, // 最后一个用SVG星星
]

function isMobile() {
  return /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent)
}

async function onDownloadClick() {
  if (isMobile()) {
    alert('请到电脑端下载插件');
    return;
  }
  try {
    const res = await checkVersion('0.0.0')
    if (res.code === 200 && res.data && res.data.downPath) {
      window.location.href = res.data.downPath
    } else {
      alert(res.message || '获取下载链接失败')
    }
  } catch (e) {
    alert('网络错误，获取下载链接失败')
  }
}

function onDocClick() {
  window.open('https://qcn0uu72n24r.feishu.cn/wiki/OLTSwVOeLiFIL5kg64vctp4EnWl', '_blank')
}

// 处理价格组件的下载插件事件
function handleDownloadPlugin(plan) {
  if (isMobile()) {
    alert('请到电脑端下载插件');
    return;
  }
  try {
    // 调用现有的下载方法
    onDownloadClick()
  } catch (e) {
    alert('下载失败，请稍后重试')
  }
}

// 显示客服微信弹窗
function showCustomerServiceModal() {
  customerServiceVisible.value = true
}

// 价格方案点击事件
function onPricingClick() {
  // 跳转到价格页面
  window.location.href = '/pricing'
}

onMounted(async () => {
  document.title = '聚宝铺-首页'
  try {
    const res = await getShopPrices()
    if (res.code === 200 && res.data) {
      vipPlans.value = res.data
    }
  } catch (e) {
    // 可以根据需要添加错误提示
    console.error('获取VIP信息失败', e)
  }
})
</script>

<style scoped>
.home-root {
  min-height: 100vh;
  background: #f7faff;
  color: #222;
  font-family: 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}
.main-section {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  padding: 64px 0 0 0;
}
.main-title {
  font-size: 2.8rem;
  font-weight: bold;
  color: #2979ff;
  margin-bottom: 18px;
}
.main-desc {
  color: #2979ff;
  font-size: 1.18rem;
  margin-bottom: 32px;
}
.main-btns {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 40px;
}
.main-btn {
  background: linear-gradient(90deg, #4ba3fa 0%, #2979ff 100%);
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 10px 28px;
  font-size: 1.08rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px #4ba3fa33;
  transition: background 0.2s;
}
.main-btn:hover {
  background: linear-gradient(90deg, #2979ff 0%, #4ba3fa 100%);
  box-shadow: 0 4px 16px #2979ff33;
}
.ghost-btn {
  background: #fff;
  color: #2979ff;
  border: 1.5px solid #4ba3fa;
  border-radius: 24px;
  padding: 10px 24px;
  font-size: 1.08rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.ghost-btn:hover {
  background: #eaf3fb;
  color: #2979ff;
}
.main-banner img {
  width: 100%;
  max-width: 900px;
  border-radius: 24px;
  box-shadow: 0 8px 32px #4ba3fa22;
  background: #eaf3fb;
}
.carousel-section {
  width: 99.7vw;
  margin-left: calc(-50vw + 50%);
  /* margin-top: 56px; */
  background: #fff;
  overflow: hidden;
}
.carousel-container {
  width: 100%;
  padding: 0;
}
.carousel-item {
  position: relative;
  /* height: 400px; */
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* overflow: hidden; */
}
.carousel-image {
  width: 100%;
  /* height: 100%; */
  object-fit: cover;
}

/* 小屏幕图片样式优化 */
@media (max-width: 768px) {
  .carousel-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
  }
}

/* 轮播图响应式样式 */
@media (max-width: 768px) {
  .carousel-item {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .carousel-item {
    height: 250px;
  }
}

/* H5移动端样式 */
@media (max-width: 768px) {
  .home-root {
    max-width: 100vw;
    overflow-x: hidden;
    background: linear-gradient(135deg, #f8fbff 0%, #e3f2fd 100%);
  }
  
  /* 确保所有网格容器不换行 */
  .enterprise-grid,
  .pricing-images-grid,
  .feature-grid {
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
    overflow-x: auto !important;
    -ms-overflow-style: none;  /* IE 和 Edge */
    scrollbar-width: none;  /* Firefox */
  }
  
  /* 确保所有网格项目不换行 */
  .enterprise-item,
  .pricing-image-item,
  .feature-item {
    flex-shrink: 0 !important;
    flex: 0 0 auto !important;
  }
  
     .carousel-section {
     width: 100%;
     /* background: linear-gradient(135deg, #fff 0%, #fff 100%); */
     overflow: hidden;
     margin: 0;
     padding: 0;
     position: relative;
     height: 300px;
   }
  
     .carousel-item {
     height: 300px;
     position: relative;
   }
  
  .carousel-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
    filter: brightness(0.9);
  }
  
  /* 轮播图内容 */
  .carousel-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 2;
    width: 90%;
  }
  
  .carousel-title {
    font-size: 2.2rem;
    font-weight: bold;
    margin-bottom: 16px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .carousel-subtitle {
    font-size: 1.1rem;
    margin-bottom: 24px;
    line-height: 1.6;
    opacity: 0.95;
  }
  
  .carousel-btn {
    background: #ff4757;
    color: white;
    border: none;
    border-radius: 25px;
    padding: 12px 32px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(255, 71, 87, 0.3);
    transition: all 0.3s ease;
  }
  
  .carousel-btn:hover {
    background: #ff3742;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 71, 87, 0.4);
  }
  
  .feature-section {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 0;
    padding: 0;
    /* background: white; */
  }
  
  .feature-card {
    background: transparent;
    border-radius: 0;
    padding: 0;
    max-width: 100%;
    width: 100%;
    color: #222;
    margin: 0 auto;
  }
  
  .feature-main-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 16px;
    color: #222;
    position: relative;
  }
  
  .feature-main-title::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #2979ff;
    border-radius: 2px;
  }
  
  .feature-sub-title {
    text-align: center;
    color: #666;
    font-size: 1rem;
    margin-bottom: 32px;
    margin-top: 24px;
    line-height: 1.6;
  }
  
  .feature-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 20px;
    justify-content: center;
    flex-direction: unset !important;
    flex-wrap: nowrap;
  }
  
  .feature-item {
    /* background: white; */
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(41, 121, 255, 0.08);
    padding: 24px 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    border: 1px solid #f0f4ff;
    min-width: auto !important;
    max-width: none !important;
    flex: 1 1 auto !important;
    width: 90% !important;
  }
  
  .feature-item:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(41, 121, 255, 0.15);
  }
  
  .feature-icon {
    font-size: 2.5rem;
    margin-bottom: 16px;
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    border-radius: 16px;
  }
  
  .feature-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
  }
  
  .enterprise-section {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 0;
    padding: 40px 20px;
    background: transparent;
    position: relative;
    z-index: 1;
    margin-bottom: 0;
  }
  
  .enterprise-card {
    border-radius: 0;
    padding: 0;
    max-width: 100%;
    width: 100%;
    color: #222;
    margin: 0 auto;
  }
  
  .enterprise-main-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 16px;
    color: #222;
    position: relative;
  }
  
  .enterprise-main-title::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #2979ff;
    border-radius: 2px;
  }
  
  .enterprise-sub-title {
    text-align: center;
    color: #666;
    font-size: 1rem;
    margin-bottom: 32px;
    line-height: 1.6;
    margin-top: 24px;
  }
  
  .enterprise-grid {
    display: flex;
    gap: 16px;
    margin-top: 32px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  
  .enterprise-item {
    /* background: white; */
    border-radius: 20px;
    box-shadow: 0 6px 24px rgba(75, 163, 250, 0.08);
    padding: 24px;
    border: 1px solid #f0f4ff;
    transition: all 0.3s ease;
    min-width: 280px;
    max-width: 330px;
    flex-shrink: 0;
    scroll-snap-align: start;
    margin-left: 25px;
    flex: 0 0 auto;
  }
  
  .enterprise-item:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(75, 163, 250, 0.15);
  }
  
  .enterprise-avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #e8f4ff;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(75, 163, 250, 0.2);
  }
  
  .enterprise-header {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 16px;
  }
  
  .enterprise-item-name {
    font-size: 1.2rem;
    font-weight: bold;
    color: #222;
    margin-bottom: 6px;
  }
  
  .enterprise-item-role {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 12px;
  }
  
  .enterprise-item-desc {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.7;
    margin-top: 0;
    text-align: left;
    letter-spacing: 0.3px;
  }
  
  .pricing-images-section {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding: 40px 20px;
    /* background: white; */
    position: relative;
    z-index: 10;
    border-top: 1px solid #e0e0e0;
  }
  
     .pricing-images-card {
     background: transparent;
     border-radius: 0;
     padding: 0;
     max-width: 80%;
     width: 100%;
     color: #222;
     margin: 0 auto;
   }
  
  .pricing-images-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 32px;
    color: #222;
    position: relative;
  }
  
  .pricing-images-title::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #2979ff;
    border-radius: 2px;
  }
  
  .pricing-images-grid {
    display: flex;
    gap: 16px;
    margin-top: 32px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  
  .pricing-image-item {
      margin-top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      border-radius: 16px;
      box-shadow: none;
      border: none;
      transition: all 0.3s ease;
      cursor: pointer;
      overflow: hidden;
      min-width: 200px;
      height: 250px;
      flex-shrink: 0;
      scroll-snap-align: start;
      flex: 0 0 auto;
    }
  
     .pricing-image-item:hover {
     transform: translateY(-4px);
     box-shadow: none;
   }
  
     .pricing-image-item img {
     width: 100%;
     height: 100%;
     object-fit: cover;
     transition: transform 0.3s ease;
   }
  
  .pricing-image-item:hover img {
    transform: scale(1.05);
  }
  
  .pricing-images-button {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
  
  .pricing-btn {
    background: linear-gradient(135deg, #2979ff 0%, #4ba3fa 100%);
    color: white;
    border: none;
    border-radius: 25px;
    padding: 16px 40px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 6px 20px rgba(41, 121, 255, 0.3);
  }
  
  .pricing-btn:hover {
    background: linear-gradient(135deg, #4ba3fa 0%, #2979ff 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(41, 121, 255, 0.4);
  }
}

.feature-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.feature-card {
  background: transparent;
  border-radius: 24px;
  padding: 40px 48px;
  max-width: 1800px;
  width: 100%;
  color: #222;
  margin: 0 auto;
}
.feature-main-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 12px;
  color: #222;
  position: relative;
}

.feature-main-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 3px;
  background: #2979ff;
  border-radius: 2px;
}
.feature-sub-title {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 32px;
  margin-top: 30px;
}
.feature-visual {
  position: relative;
  width: 480px;
  height: 260px;
  margin: 0 auto 32px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.visual-bg {
  position: absolute;
  left: 0; top: 0;
  z-index: 1;
}
.visual-center {
  position: absolute;
  left: 50%; top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  box-shadow: 0 0 16px 2px #4b70eb33, 0 0 0 4px #fff3;
  border-radius: 18px;
  background: #fff;
  padding: 10px;
}
.visual-logo {
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background: #eaf3fb;
  box-shadow: 0 0 8px #4b70eb33;
}
.visual-label {
  position: absolute;
  z-index: 3;
  min-width: 56px;
  padding: 6px 16px;
  border-radius: 16px;
  background: rgba(75,112,235,0.18);
  color: #4b70eb;
  font-size: 1.08rem;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 2px 8px #4b70eb22;
  border: 1.5px solid #4b70eb88;
  backdrop-filter: blur(2px);
  text-shadow: 0 2px 8px #fff, 0 1px 0 #4b70eb22;
  letter-spacing: 1px;
}
.visual-ai {
  left: 50%; top: 28px;
  transform: translate(-50%, 0);
}
.visual-batch {
  left: 32px; top: 130px;
  transform: translate(0, -50%);
}
.visual-jingxi {
  right: 32px; top: 130px;
  transform: translate(0, -50%);
}
.visual-auto {
  left: 50%; bottom: 28px;
  transform: translate(-50%, 0);
}
.feature-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 32px 24px;
  justify-content: center;
}
.feature-item {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 12px #2979ff11;
  padding: 32px 12px 24px 12px;
  min-width: 340px;
  max-width: 340px;
  flex: 1 1 220px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.2s, transform 0.2s;
}
.feature-item:hover {
  box-shadow: 0 8px 24px #2979ff22;
  transform: translateY(-6px) scale(1.03);
}
.feature-icon {
  font-size: 2.8rem;
  margin-bottom: 18px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feature-title {
  font-size: 1.08rem;
  font-weight: bold;
  color: #222;
  word-break: break-all;
}
@media (max-width: 1200px) {
  .feature-item {
    flex: 1 1 45%;
    min-width: 140px;
    max-width: 100%;
  }
}
@media (max-width: 900px) {
  .feature-grid {
    flex-direction: column;
    gap: 12px;
  }
  .feature-item {
    flex: 1 1 100%;
    min-width: 100px;
    max-width: 100%;
  }
}

/* 企业级解决方案部分样式 */
.enterprise-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0;
  /* background: #fff; */
  padding: 40px 0;
}

.enterprise-card {
  /* background: #fff; */
  border-radius: 24px;
  padding: 40px 48px;
  max-width: 1530px;
  width: 100%;
  color: #222;
  margin: 0 auto;
}

.enterprise-main-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 12px;
  color: #222;
  position: relative;
}

.enterprise-main-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 3px;
  background: #2979ff;
  border-radius: 2px;
}

.enterprise-sub-title {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 32px;
  line-height: 1.6;
  margin-top: 30px;
}

.enterprise-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 80px;
  margin-top: 32px;
}

.enterprise-item {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(75, 163, 250, 0.1);
  padding: 24px;
  border: 1px solid #e8f4ff;
  transition: all 0.3s ease;
}

.enterprise-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(75, 163, 250, 0.2);
}

.enterprise-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #e8f4ff;
  flex-shrink: 0;
}

.enterprise-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.enterprise-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.enterprise-tag-blue {
  background: #e3f2fd;
  color: #42a5f5;
  border: 1px solid #42a5f5;
}

.enterprise-tag-green {
  background: #e8f5e8;
  color: #66bb6a;
  border: 1px solid #66bb6a;
}

.enterprise-tag-orange {
  background: #fff3e0;
  color: #ff9800;
  border: 1px solid #ff9800;
}

.enterprise-tag-orange-light {
  background: #fff3e0;
  color: #ff9800;
  border: 1px solid #ff9800;
}

.enterprise-tag-orange-dark {
  background: #fff3e0;
  color: #ff9800;
  border: 1px solid #ff9800;
}

.enterprise-item-name {
  font-size: 1.2rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 4px;
}

.enterprise-item-role {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 12px;
}

.enterprise-header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 16px;
}

.enterprise-info {
  flex: 1;
  text-align: left;
}

.enterprise-item-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.8;
  margin-top: 0;
  text-align: left;
  letter-spacing: 2px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .enterprise-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

/* 超小屏幕优化 */
@media (max-width: 480px) {
  .enterprise-grid,
  .pricing-images-grid {
    gap: 12px;
    margin-left: 16px;
    margin-right: 16px;
  }
  
  .enterprise-item {
    min-width: 260px;
    padding: 20px;
  }
  
  .pricing-image-item {
    min-width: 180px;
    height: 220px;
  }
  
  .pricing-image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .feature-grid {
    gap: 16px;
  }
  
  .feature-item {
    padding: 20px 12px;
  }
}

@media (max-width: 768px) {
  .enterprise-grid {
    display: flex !important;
    grid-template-columns: unset !important;
    gap: 16px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
    margin-left: 28px;
    margin-right: 28px;
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
  }
  
  .enterprise-item {
    min-width: 280px;
    flex-shrink: 0;
    scroll-snap-align: start;
  }
  
  .enterprise-card {
    padding: 24px 16px;
  }
  
  .enterprise-main-title {
    font-size: 1.8rem;
  }
}

/* 客服微信弹窗样式 */
.customer-service-content {
  text-align: center;
  padding: 20px 0;
}

.customer-service-qr {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.customer-service-text {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.customer-service-wechat {
  color: #2979ff;
  font-weight: bold;
  font-size: 16px;
}

/* 价格方案图片展示部分样式 */
.pricing-images-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0;
  padding: 40px 0;
}

.pricing-images-card {
  background: transparent;
  border-radius: 24px;
  padding: 40px 48px;
  max-width: 1530px;
  width: 100%;
  color: #222;
  margin: 0 auto;
}

.pricing-images-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 40px;
  color: #222;
  position: relative;
}

.pricing-images-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 3px;
  background: #2979ff;
  border-radius: 2px;
}

.pricing-images-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 32px;
}

.pricing-image-item {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #fff; */
  border-radius: 16px;
  /* box-shadow: 0 4px 24px rgba(75, 163, 250, 0.1); */
  /* border: 1px solid #e8f4ff; */
  transition: all 0.3s ease;
  height: 450px;
  cursor: pointer;
}

.pricing-image-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(75, 163, 250, 0.2);
  border-color: #2979ff;
}

@media (min-width: 769px) {
  .pricing-image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.pricing-images-button {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.pricing-btn {
  background: #fff;
  color: #2979ff;
  border: 2px solid #2979ff;
  border-radius: 5px;
  padding: 12px 32px;
  font-size: 1.1rem;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(41, 121, 255, 0.2);
}

.pricing-btn:hover {
  background: #2979ff;
  color: #fff;
  box-shadow: 0 4px 16px rgba(41, 121, 255, 0.3);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .pricing-images-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .pricing-images-grid {
    display: flex !important;
    grid-template-columns: unset !important;
    gap: 16px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
  }
  
  .pricing-image-item {
    min-width: 200px;
    flex-shrink: 0;
    scroll-snap-align: start;
    height: 300px;
  }
  
  .pricing-image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .pricing-images-card {
    padding: 24px 16px;
  }
  
  .pricing-images-title {
    font-size: 1.8rem;
  }
}
</style> 